import React, { FC } from 'react';
import { useAppSelector } from 'src/app/hooks';
import { Role } from 'src/store/models/Auth';

import AdminSettings from './AdminSettings/AdminSettings';
import ManufacturerSettings from './ManufacturerSettings/ManufacturerSettings';
import ServiceSettings from './ServiceSettings/ServiceSettings';

const Settings: FC = () => {
  const user = useAppSelector((state) => state.auth.user);

  return user?.role === Role.SERVICE ? (
    <ServiceSettings />
  ) : user?.role === Role.MANUFACTURER ? (
    <ManufacturerSettings />
  ) : (
    user?.role === Role.ADMIN && <AdminSettings />
  );
};

export default Settings;
